import { Container } from '@chakra-ui/react';
import { Response } from 'datx-jsonapi';
import { Fragment, useMemo } from 'react';
import { InView } from 'react-intersection-observer';

import { OriginalsSection } from '@/components/ui/features/library/OriginalsSection/OriginalsSection';
import { SubjectSection } from '@/components/ui/features/library/SubjectSection/SubjectSection';
import { useResourcesInfinite } from '@/lib/datx-jsonapi-react';
import { queryThinSubjectsInfinite } from '@/queries/thin-subjects';
import { ThinSubject } from '@/resources/ThinSubject';
import { extractSWRInfiniteData } from '@/utils/swr/extractSWRInfiniteData';

export const LecturePageContent = () => {
  const { data, error, size, setSize } = useResourcesInfinite(
    queryThinSubjectsInfinite({
      filters: {
        scope: 'library_featured',
      },
      sort: 'position',
      pageSize: 4,
    })
  );

  const { items, isLoadingMore, isReachingEnd } = useMemo(
    () => extractSWRInfiniteData<ThinSubject>(data as Array<Response<ThinSubject>>, error, size),
    [data, error, size]
  );

  const postOriginalsItems = items?.slice(2);

  return (
    <Fragment>
      <Container px={{ base: 5, md: 10, lg: 5 }} pr={{ base: 0, md: 'inherit' }}>
        <SubjectSection subject={items?.[0]} mt="48px" />
        <SubjectSection subject={items?.[1]} mt="48px" />
      </Container>

      <OriginalsSection mt="48px" />

      <Container px={{ base: 5, md: 10, lg: 5 }} pr={{ base: 0, md: 'inherit' }}>
        {postOriginalsItems?.map((subject) => {
          return <SubjectSection key={subject.id} subject={subject} mt="48px" _last={{ mb: '156px' }} />;
        })}
      </Container>

      <InView
        as="span"
        onChange={(inView) => {
          if (inView && !error && !isReachingEnd && !isLoadingMore) {
            setSize(size + 1);
          }
        }}
      ></InView>
    </Fragment>
  );
};
